module.exports = __webpack_public_path__ + "static/img/teacher_tip.32352e15.png";